export enum ImageBaseTypes {
  Person = "PERSON",
  Entity = "ENTITY",
  EntityGroup = "ENTITYGROUP",
  Competition = "COMPETITION",
  Season = "SEASON",
  League = "LEAGUE",
  Organization = "ORGANIZATION",
  Division = "DIVISION",
  Conference = "CONFERENCE",
  Uniform = "UNIFORM",
  UniformItem = "UNIFORM_ITEM",
}
